// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2djOP","field":"styles_field__2IupO","fieldCol":"styles_fieldCol__2gMhO","diffCol":"styles_diffCol__CvmkH","diff":"styles_diff__10DM8"};